import MachineDetail from "assets/Svgs/MachineDetail.svg";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import {
  AppBar,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
  Paper,
  Skeleton,
  Tooltip,
  Typography,
} from "@mui/material";
import i18n from "i18n/i18n";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import { ReactComponent as SpaceDashboardSVG } from "assets/Svgs/SpaceDashSVG.svg";
import { ReactComponent as ArtSvg } from "assets/Svgs/ArtSvg.svg";
import { ReactComponent as TagSvg } from "assets/Svgs/TagSvg.svg";
import { useLocation } from "react-router-dom";
import { ReactComponent as WerkSVG } from "assets/Svgs/WerkSvg.svg";
import Overview from "./tabs/Overview";
import { useBoundStore } from "store/store";
import History from "./tabs/History";
import { ReactComponent as RoundedbackSvg } from "assets/Svgs/RoundedBack.svg";
import Documentation from "./tabs/Documentation/Documentation";
import DeviceMessages from "./tabs/DeviceMessages";
import Faq from "./tabs/Faq/Faq";
import Maintenance from "./tabs/Maintenance/Maintenance";
import mqtt from "mqtt";
import DeletePopUp from "components/DeletePopup";
import EquipmentPhotoWrapper from "assets/Svgs/no-machine.jpg";
import { truncateWithEllipses } from "utils/helper";

function MachineDetailPage() {

  const lang: any = useBoundStore((state) => state.lang);

  const legalentitynodeid = useBoundStore((state) => state.legalEntityNodeId);

  const isAuthUser: any = useBoundStore((state) => state.isAuthUser);

  const deleteEqConfig: any = useBoundStore((state) => state.deleteEqConfig);

  const location = useLocation();

  const subscribedEquipments = useBoundStore(
    (state) => state.subscribedEquipments
  );

  const loadTopology: any = useBoundStore((state) => state.loadTopology);

  const [navigatee, setNavigatee] = useState(false);

  const navigate = useNavigate();

  const selectEquipment = useBoundStore((state) => state.selectEquipment);

  const loadEquipmentDetails = useBoundStore(
    (state) => state.loadEquipmentDetails
  );

  const clearMachine = useBoundStore((state) => state.clearMachine);

  const [activeTab, setActiveTab] = useState<number>(0);
  

  const params = new URLSearchParams(location.search);
  let nodeid: any = params.get("nodeid");
  const tab = params.get("tab");

  nodeid = nodeid?.split("&")[0];

  useEffect(() => {
    clearMachine();
    setActiveTab(Number(tab));
    if (tab == "3") {
      setTimeout(function () {
        loadEquipmentDetails(nodeid);
      }, 2000);
    } else if (tab == "4") {
      setTimeout(function () {
        loadEquipmentDetails(nodeid);
      }, 2000);
    } else if (tab == "0" && nodeid) {
      setTimeout(function () {
        loadEquipmentDetails(nodeid);
      }, 2000);
    } else if (
      location?.state != undefined &&
      location?.state?.machineNodeId !== ""
    ) {
      loadEquipmentDetails(location?.state?.machineNodeId);
    }
  }, [location.state, location.search]);

  useEffect(() => {
    
    selectEquipment(subscribedEquipments);
  }, [subscribedEquipments]);

  const handleTabChange = (event: any, newValue: any) => {
    setActiveTab(newValue);
  };

  const handleClick = (event: any) => {
    setanchorEl(event.currentTarget);
    setopen(true);
  };

  const [anchorEl, setanchorEl] = useState(null);
  const [open, setopen] = useState(false);

  const handleClose = () => {
    setanchorEl(null);
    setopen(false);
  };

  interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: number;
    value: number;
  }

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const [openDialogDelete, setopenDialogDelete] = useState(false);

  const handleDialogDelete = () => {
    setopenDialogDelete(false);
  };

  const handleDelete = async () => {
    
    let _nodeid = location?.state?.machineNodeId ? location?.state?.machineNodeId : nodeid;

    const promises = await deleteEqConfig({ nodeid : _nodeid,legalentitynodeid });
    if (isAuthUser === true) {
      try {
        const result = await Promise.all(promises);

        await loadTopology(lang);

        if(location.state.sitenodeid){
          navigate("/sites?sitenodeid=" + location.state.sitenodeid);
        }
        else{
          navigate("/maintenance");
        }
      } catch (error) {
        console.error("Error during promise execution:", error);
      }
    }
  };

  return (
    <>
      <DeletePopUp
        open={openDialogDelete}
        handleClose={handleDialogDelete}
        handleDelete={handleDelete}
      ></DeletePopUp>

      <div
        className="breadcrumpsWrapper"
        onClick={() => {
          navigate("/maintenance");
        }}
      >
        <div className="backIcon">
          <RoundedbackSvg />
        </div>
        <div className="breadcrumps">{i18n(lang)?.all_devices}</div>
      </div>

      {subscribedEquipments === undefined ? (
        <Paper>
          <div className="MO_Skeliton_Wrapper">
            {" "}
            <Box>
              <div className="MO_Skeliton">
                <div>
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                </div>
                <div>
                  <Skeleton
                    animation="wave"
                    variant="rounded"
                    id="MO_Skeliton_Image"
                  />
                </div>
              </div>
            </Box>
            <Divider />
            <Box>
              <Skeleton
                animation="wave"
                width={200}
                variant="text"
                sx={{ fontSize: "1rem", marginTop: "15px" }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "23px",
                }}
              >
                <Skeleton
                  variant="rounded"
                  width={"100%"}
                  height={97}
                  animation="wave"
                  sx={{ marginRight: "3%" }}
                />
                <Skeleton
                  variant="rounded"
                  width={"100%"}
                  height={97}
                  animation="wave"
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "23px",
                }}
              >
                <Skeleton
                  variant="rounded"
                  width={"100%"}
                  height={97}
                  animation="wave"
                  sx={{ marginRight: "3%" }}
                />
                <Skeleton
                  variant="rounded"
                  width={"100%"}
                  height={97}
                  animation="wave"
                />
              </div>
            </Box>
          </div>
        </Paper>
      ) : (
        <div className="bxShadow MD_page">
          <div className="MD_Wrapper">
            <div className="_content" style={{ height: "100%"}}>
              <div className="_primaryContent" style={{ height: "50%"}}>
                <div className="_content">
                  <Tooltip title={subscribedEquipments?.equipment?.name}>
                    <div>
                      {truncateWithEllipses(
                        subscribedEquipments?.equipment?.name,
                        30
                      )}
                    </div>
                  </Tooltip>
                  <div>Mesutronic</div>
                </div>
                <div className="_actionButtons">
                  <IconButton
                    className={"moreFilterButton"}
                    aria-label="more"
                    sx={{ color: "#ffffff" }}
                    aria-controls="long-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                    style={{ paddingRight: "0px" }}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    keepMounted
                  >
                    <MenuList className="mo_menu">
                      <MenuItem>
                        <Typography variant="inherit">
                          <Link
                            to="/create-equipment"
                            state={{
                              pageType: "edit",
                              equipment: subscribedEquipments,
                              from: "machinePage",
                            }}
                            style={{ display: "flex", color: "black" }}
                          >
                            <div
                              style={{
                                display: "flex",
                                margin: "10px",
                                alignItems: "center",
                              }}
                            >
                              <div>
                                <ListItemIcon sx={{ color: "#38748D" }}>
                                  <ModeEditOutlinedIcon fontSize="small" />
                                </ListItemIcon>
                              </div>
                              <div
                                style={{
                                  marginLeft: "-11px",
                                  textTransform: "uppercase",
                                }}
                              >
                                {i18n(lang)?.edit}
                              </div>
                            </div>
                          </Link>
                        </Typography>
                      </MenuItem>

                      <Divider />
                      <MenuList sx={{ padding: "0px 15px 15px 15px" }}>
                        <MenuItem
                          onClick={() => {
                            setopenDialogDelete(true);
                          }}
                        >
                          <ListItemIcon style={{ minWidth: "22px" }}>
                            <svg
                              width="16"
                              height="18"
                              viewBox="0 0 16 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3 18C2.45 18 1.97933 17.8043 1.588 17.413C1.196 17.021 1 16.55 1 16V3C0.716667 3 0.479 2.90433 0.287 2.713C0.0956668 2.521 0 2.28333 0 2C0 1.71667 0.0956668 1.479 0.287 1.287C0.479 1.09567 0.716667 1 1 1H5C5 0.716667 5.096 0.479 5.288 0.287C5.47933 0.0956666 5.71667 0 6 0H10C10.2833 0 10.521 0.0956666 10.713 0.287C10.9043 0.479 11 0.716667 11 1H15C15.2833 1 15.5207 1.09567 15.712 1.287C15.904 1.479 16 1.71667 16 2C16 2.28333 15.904 2.521 15.712 2.713C15.5207 2.90433 15.2833 3 15 3V16C15 16.55 14.8043 17.021 14.413 17.413C14.021 17.8043 13.55 18 13 18H3ZM3 3V16H13V3H3ZM8 10.9L9.9 12.8C10.1 12.9833 10.3377 13.075 10.613 13.075C10.8877 13.075 11.1167 12.9833 11.3 12.8C11.5 12.6 11.6 12.3623 11.6 12.087C11.6 11.8123 11.5 11.5833 11.3 11.4L9.4 9.5L11.3 7.6C11.5 7.4 11.6 7.16233 11.6 6.887C11.6 6.61233 11.5 6.38333 11.3 6.2C11.1167 6 10.8877 5.9 10.613 5.9C10.3377 5.9 10.1 6 9.9 6.2L8 8.1L6.1 6.2C5.91667 6 5.68767 5.9 5.413 5.9C5.13767 5.9 4.9 6 4.7 6.2C4.51667 6.38333 4.425 6.61233 4.425 6.887C4.425 7.16233 4.51667 7.4 4.7 7.6L6.6 9.5L4.7 11.4C4.51667 11.5833 4.425 11.8123 4.425 12.087C4.425 12.3623 4.51667 12.6 4.7 12.8C4.9 12.9833 5.13767 13.075 5.413 13.075C5.68767 13.075 5.91667 12.9833 6.1 12.8L8 10.9Z"
                                fill="#FF3D00"
                              />
                            </svg>
                          </ListItemIcon>
                          <ListItemText>{i18n(lang).delete}</ListItemText>
                        </MenuItem>
                      </MenuList>
                    </MenuList>
                  </Menu>
                </div>
              </div>
              <div className="_secondaryContent" style={{ height: "51%"}}>
                <div className="flex">
                  <div className="_status">
                    <SpaceDashboardSVG /> {i18n(lang)?.single_area} :
                    {" " +
                      subscribedEquipments?.equipment?.isequipmentof[0]?.area
                        ?.name}
                  </div>

                  <div className="_status" style={{ marginLeft: "30px" }}>
                    <WerkSVG /> 
                    {" " +
                      subscribedEquipments?.equipment?.isequipmentof[0]?.area
                        ?.isareaof[0]?.site?.name}
                  </div>
                </div>

                <div className="flex">
                  <div className="_status">
                    {i18n(lang).inv_id} :{" "}
                    <Tooltip
                      title={subscribedEquipments?.equipment?.inventoryid}
                    >
                      <span>
                        {truncateWithEllipses(
                          subscribedEquipments?.equipment?.inventoryid,
                          30
                        )}
                      </span>
                    </Tooltip>
                  </div>

                  <div className="_status" style={{ marginLeft: "30px" }}>
                   {i18n(lang).eq_id} :{" "}
                    <Tooltip
                      title={subscribedEquipments?.equipment?.equipmentid}
                    >
                      <span>
                        {truncateWithEllipses(
                          subscribedEquipments?.equipment?.equipmentid,
                          30
                        )}
                      </span>
                    </Tooltip>
                  </div>
                </div>

                <div className="flex">
                  <div className="_status">
                     {i18n(lang).device_serial_number}
                    <Tooltip
                      title={
                        subscribedEquipments?.equipment
                          ?.manufacturerserialnumber
                      }
                    >
                      <span>
                        {truncateWithEllipses(
                          subscribedEquipments?.equipment
                            ?.manufacturerserialnumber,
                          30
                        )}
                      </span>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>

            <div className="_image">
              {subscribedEquipments?.equipment?.image?.url ? (
                <img src={subscribedEquipments?.equipment?.image?.url} />
              ) : (
                <img src={EquipmentPhotoWrapper} style={{ objectFit:"cover"}}/>
              )}
            </div>
          </div>

          <Box sx={{ bgcolor: "background.paper" }}>
            <AppBar position="static" sx={{ boxShadow: "none" }}>
              <Tabs
                className="MD_tabs"
                value={activeTab}
                onChange={handleTabChange}
                variant="scrollable"
              >
                <Tab
                  label={i18n(lang)?.tab_overview}
                  sx={{ color: "inherit", width: "150px" }}
                />
                <Tab
                  label={i18n(lang)?.tab_history}
                  sx={{ color: "inherit", width: "150px" }}
                />
                <Tab
                  label={i18n(lang)?.tab_documentation}
                  sx={{ color: "inherit", width: "150px" }}
                />
                <Tab
                  label={i18n(lang)?.tab_faq}
                  sx={{ color: "inherit", width: "150px" }}
                />
                <Tab
                  label={i18n(lang)?.tab_maintenance}
                  sx={{ color: "inherit", width: "150px" }}
                />
                <Tab
                  label={i18n(lang)?.tab_device_messages}
                  sx={{ color: "inherit", width: "250px" }}
                />
              </Tabs>
            </AppBar>
            <TabPanel value={activeTab} index={0}>
              <Overview machineData={subscribedEquipments} />
            </TabPanel>
            <TabPanel value={activeTab} index={1}>
              <History machineData={subscribedEquipments} />
            </TabPanel>
            <TabPanel value={activeTab} index={2}>
              <Documentation machineData={subscribedEquipments} />
            </TabPanel>
            <TabPanel value={activeTab} index={3}>
              <Faq machineData={subscribedEquipments} />
            </TabPanel>
            <TabPanel value={activeTab} index={4}>
              <Maintenance machineData={subscribedEquipments} />
            </TabPanel>
            <TabPanel value={activeTab} index={5}>
              <DeviceMessages machineData={subscribedEquipments} />
            </TabPanel>
          </Box>
        </div>
      )}
    </>
  );
}

export default MachineDetailPage;
